// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoicePdf .CustomPdfTable {
  --sp-table-header-bg: #40ade2;
  border-radius: 5px 5px 0 0;
}
.InvoicePdf .CustomPdfTable .TableRow.CustomPdfTable-Header {
  border-radius: 4px 4px 0 0;
  color: #ffffff;
}
.InvoicePdf .CustomPdfTable .TableRow.CustomPdfTable-SubtotalRow {
  background-color: rgba(0, 0, 0, 0.045);
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.INDEX {
  width: 5%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.TYPE {
  width: 15%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.NOTE {
  width: 60%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.COST {
  width: 20%;
  text-align: end;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.LABEL {
  width: 80%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.COUNT {
  width: 55%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.COUNT + .LABEL {
  width: 25%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.SUBTOTAL {
  width: 20%;
}
.InvoicePdf .CustomPdfTable .TableRow .TableCell.LABEL, .InvoicePdf .CustomPdfTable .TableRow .TableCell.SUBTOTAL {
  text-align: end;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/layouts/Invoice/CustomPdfTable/styles.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;EACA,0BAAA;AAAJ;AAEM;EACE,0BAAA;EACA,cAAA;AAAR;AAEM;EACE,sCAAA;AAAR;AAIQ;EACE,SAAA;AAFV;AAIQ;EACE,UAAA;AAFV;AAIQ;EACE,UAAA;AAFV;AAIQ;EACE,UAAA;EACA,eAAA;AAFV;AAKQ;EACE,UAAA;AAHV;AAKQ;EACE,UAAA;AAHV;AAIU;EACE,UAAA;AAFZ;AAKQ;EACE,UAAA;AAHV;AAKQ;EAEE,eAAA;AAJV","sourcesContent":[".InvoicePdf {\n  .CustomPdfTable {\n    --sp-table-header-bg: #40ade2;\n    border-radius: 5px 5px 0 0;\n    .TableRow {\n      &.CustomPdfTable-Header {\n        border-radius: 4px 4px 0 0;\n        color: #ffffff;\n      }\n      &.CustomPdfTable-SubtotalRow {\n        background-color: rgba(0, 0, 0, 0.045);\n      }\n      .TableCell {\n        // Custom Charge Row\n        &.INDEX {\n          width: 5%;\n        }\n        &.TYPE {\n          width: 15%;\n        }\n        &.NOTE {\n          width: 60%;\n        }\n        &.COST {\n          width: 20%;\n          text-align: end;\n        }\n        // Subtotal Row\n        &.LABEL {\n          width: 80%;\n        }\n        &.COUNT {\n          width: 55%;\n          + .LABEL {\n            width: 25%;\n          }\n        }\n        &.SUBTOTAL {\n          width: 20%;\n        }\n        &.LABEL,\n        &.SUBTOTAL {\n          text-align: end;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
